import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { AuthContext } from "../../context/AuthContextProvider.js";
import * as Yup from "yup";
import { userProfileUpdate } from "../../api/settings";
import {
  sendUpdatePatientOtp,
  verifyUpdatePatientOtp,
  updatePatientWithSession,
} from "../../api/collection";
import { toast } from "sonner";
import moment from "moment";
import { Helmet } from "react-helmet";
import CountryCodePicker from "../../components/CountryCodePicker";
import OtpInput from "../../components/Reusables/FormControls/FormOtpVerify";
import { useForm, Controller } from "react-hook-form";
import Timer from "otp-timer";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import FormTextField from "../../components/Reusables/FormControls/FormTextFeilds.jsx";
import FormSelect from "../../components/Reusables/FormControls/FormSelect.jsx";
import FormDatePicker from "../../components/Reusables/FormControls/FormDatePicker.jsx";
import ImageUploader from "../../components/Reusables/ImageControls/ImageUploader.jsx";
const PatientProfile = ({ patient }) => {
  const { user, open } = useContext(AuthContext);
  const cleanImageUrl = (url) => {
    if (!url) return null;
    if (url.includes("undefined")) return null;
    if (url.includes("null")) return null;
    return url;
  };
  // const [patientData, setPatientData] = useState(patient);
  const defaultValues = {
    first_name: patient?.firstName || "",
    middle_name: user?.middleName || "",
    last_name: patient?.lastName || "",
    uh_id: patient?.patientId || "",
    phoneNumber: patient?.phoneNo || "",
    email: patient?.userEmail || "",
    gender: patient?.gender || "",
    dob: patient?.dateOfBirth ? moment(patient.dateOfBirth).toDate() : null,
    designation: patient?.designation || "",
    user_type: patient?.userType || "",
    referenceNumber: patient?.secondaryReferenceNumber || "",
    logo: null,
    abhaDetails: patient?.abhaDetails || {},
  };

  useEffect(() => {
    defaultValues.first_name = patient?.firstName;
    defaultValues.last_name = patient?.lastName;
    defaultValues.uh_id = patient?.patientId;
    defaultValues.phoneNumber = patient?.phoneNo;
    defaultValues.email = patient?.userEmail;
    defaultValues.gender = patient?.gender;
    defaultValues.dob = patient?.dateOfBirth
      ? moment(patient.dateOfBirth, "DD-MM-YYYY").toDate()
      : null;
    defaultValues.designation = patient?.designation;
    defaultValues.user_type = patient?.userType;
    defaultValues.referenceNumber = patient?.secondaryReferenceNumber;
    defaultValues.logo = null;
    defaultValues.abhaDetails = patient?.abhaDetails || {};
    setLogoPreview(cleanImageUrl(patient?.profile));
    setLogoFile(null);
    reset(defaultValues);
  }, [patient]);

  const {
    control,
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { isDirty, dirtyFields },
  } = useForm({ defaultValues });
  // Detect changes
  const watchedValues = watch();
  const [isChanged, setIsChanged] = useState(false);

  const [errors, setErrors] = useState({});
  const [sendOTP, setSendOTP] = useState(false);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(
    cleanImageUrl(patient?.profile),
  ); // URL or null
  const [buttonLoading, setButtonLoading] = useState(false);
  const [patientSessionToken, setPatientSessionToken] = useState(null);
  const patientId = patient?.id || patient?._id;
  const isEditable = !!patientSessionToken;
  const [sendOtpLoading, setSendOtpLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const referenceNumber = watch("referenceNumber");
  const [isImageRemoved, setIsImageRemoved] = useState(false);
  const email = watch("email");

  useEffect(() => {
    const changed = Object.keys(defaultValues).some((key) => {
      if (key === "logo") {
        return watchedValues.logo !== defaultValues.logo;
      }
      return watchedValues[key] !== defaultValues[key];
    });
    setIsChanged(changed);
  }, [watchedValues]);

  const [otp, setOtp] = useState("");
  const [verifyOtpLoading, setVerifyOtpLoading] = useState(false);
  // Reset form when user prop changes
  useEffect(() => {
    reset(defaultValues);
  }, [user]);

  // const [isButtonEditable, setIsButtonEditable] = useState(true);

  const ProfileSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("First Name is required"),
    email: Yup.string()
      .nullable()
      .notRequired()
      .email("Please enter a valid email"),
    phoneNumber: Yup.string().required("Phone Number is required"),
    gender: Yup.string().required("Gender is required"),

    // designation: Yup.string().required('Designation is required'),
    // user_type: Yup.string().required("User Type is required"),
  });

  const handlesendOTP = async () => {
    try {
      if (!patientId) {
        toast.error("Missing patient id");
        return;
      }
      setSendOtpLoading(true);
      const res = await sendUpdatePatientOtp(patientId);
      if (res?.success) {
        toast.success(res?.message || "OTP sent successfully");
        setSendOTP(true);
      } else {
        toast.error(res?.message || "Failed to send OTP");
      }
    } catch (e) {
      toast.error(e?.message || "Failed to send OTP");
    } finally {
      setSendOtpLoading(false);
    }
  };

  const otpVerification = async (otpCode) => {
    try {
      setVerifyOtpLoading(true);
      const res = await verifyUpdatePatientOtp(patientId, otpCode);
      if (res?.success) {
        const token =
          res?.patientSessionToken ||
          res?.data?.patientSessionToken ||
          res?.token ||
          res?.data?.token;
        setPatientSessionToken(token);
        setSendOTP(false);
        toast.success("OTP verified. You can now update details.");
      } else {
        toast.error(res?.message || "Invalid OTP");
      }
    } catch (e) {
      toast.error(e?.message || "OTP verification failed");
    } finally {
      setVerifyOtpLoading(false);
    }
  };

  // const handleLogoChange = (fileList) => {
  //   if (fileList.length > 0) {
  //     const file = fileList[0].blobFile;
  //     setLogoPreview(URL.createObjectURL(file)); // for preview
  //     setValue("logo", file, { shouldDirty: true }); // update RHF
  //   }
  // };

  const onSubmit = async (data) => {
    try {
      await ProfileSchema.validate(data, { abortEarly: false });
      setErrors({});

      if (!isEditable) {
        toast.error("Please verify OTP to update details");
        return;
      }

      setButtonLoading(true);

      const profileDetails = {
        gender: data.gender,
        dateOfBirth: data.dob ? moment(data.dob).format("DD-MM-YYYY") : null,
        designation: data.designation,
        firstName: data.first_name,
        lastName: data.last_name,
        email: data.email,
        referenceNumber: data.referenceNumber,
      };

      const formData = new FormData();

      formData.append("profileDetails", JSON.stringify(profileDetails));

      if (data.logo) {
        formData.append("logo", logoFile);
      }
      if (isImageRemoved && !logoFile) {
        formData.append("removeProfileImage", "true");
      }

      const response = await updatePatientWithSession(
        patientId,
        formData,
        patientSessionToken,
      );

      if (response.success) {
        toast.success("Profile updated successfully");
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      const formattedErrors = {};
      err?.inner?.forEach((e) => {
        if (e.path) formattedErrors[e.path] = e.message;
      });
      setErrors(formattedErrors);
    } finally {
      setButtonLoading(false);
      setIsChanged(false);
    }
  };
  //   useEffect(() => {
  //     if (patient !== undefined) {
  //       setLoading(false);
  //     }
  //   }, [patient]);
  //   if (loading) {
  //   return (
  //     <Container maxWidth="md" sx={{ mt: 6 }}>
  //       <Box sx={{ textAlign: "center" }}>
  //         <CircularProgress />
  //         <Typography mt={2}>Loading patient details...</Typography>
  //       </Box>
  //     </Container>
  //   );
  // }
  //   if (!patient) {
  //     return (
  //       <>
  //         <Helmet>
  //           <title>Spandan - Patient Not Found</title>
  //         </Helmet>

  //         <Container maxWidth="md" sx={{ mt: 6 }}>
  //           <Box
  //             sx={{
  //               p: 4,
  //               borderRadius: 2,
  //               backgroundColor: "#FFF5F5",
  //               border: "1px solid #FCA5A5",
  //               textAlign: "center",
  //             }}
  //           >
  //             <Typography
  //               variant="h5"
  //               sx={{ fontWeight: 700, color: "#B91C1C", mb: 1 }}
  //             >
  //               Patient Not Available
  //             </Typography>

  //             <Typography sx={{ color: "#7F1D1D" }}>
  //               User must be deleted. You won’t be able to show the data.
  //             </Typography>
  //           </Box>
  //         </Container>
  //       </>
  //     );
  //   }

  dayjs.extend(customParseFormat);

  const getDisplayAge = (patient) => {
    if (patient?.age && patient.age > 0) {
      return `${patient.age} year${patient.age > 1 ? "s" : ""}`;
    }
    const dobValue =
      patient?.businessPatients?.date_of_birth || patient?.dateOfBirth;
    if (!dobValue) return "";
    const dob = dayjs(dobValue, "DD-MM-YYYY", true);
    if (!dob.isValid()) {
      return "";
    }
    const years = dayjs().diff(dob, "year");
    if (years >= 1) {
      return `${years} year${years > 1 ? "s" : ""}`;
    }
    const months = dayjs().diff(dob, "month");
    return `${months} month${months > 1 ? "s" : ""}`;
  };

  return (
    <>
      <Helmet>
        <title>Spandan - Settings</title>
      </Helmet>

      <Container
        maxWidth={false}
        sx={{
          mt: 3,
          mb: 6,
          width: "100%",
          p: "0px !important",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            backgroundColor: "var(--app-surface)",
            borderRadius: "18px",
            px: { xs: 2, sm: 3, md: 4 },
            py: { xs: 2, sm: 3 },
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mb: 3,
                }}
              >
                {/* Avatar */}
                <Box
                  sx={{
                    borderRadius: "0%",
                    overflow: "hidden",
                    flexShrink: 0,
                  }}
                >
                  <ImageUploader
                    label=""
                    file={logoFile}
                    setFile={(file) => {
                      setLogoFile(file);
                      setValue("logo", file, { shouldDirty: true });
                      setIsImageRemoved(false);
                    }}
                    preview={logoPreview}
                    setPreview={(preview) => {
                      const cleaned = cleanImageUrl(preview);
                      setLogoPreview(cleaned);

                      if (!cleaned) {
                        setLogoFile(null);
                        setValue("logo", null, { shouldDirty: true });
                        setIsImageRemoved(true);
                      } else {
                        setIsImageRemoved(false);
                      }
                    }}
                    uploader="profile"
                    disabled={!isEditable}
                    isFromPatientProfile={true}
                  />
                </Box>

                {/* Name + Info */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "#1C1C1C",
                    }}
                  >
                    {patient?.firstName} {patient?.lastName}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "var(--app-text-muted)",
                      fontWeight: 400,
                    }}
                  >
                    {getDisplayAge(patient)} | {patient?.gender}
                  </Typography>
                </Box>
              </Box>

              {/* Input Fields */}
              <div className="row mt-2">
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                    <FormTextField
                      label="First Name"
                      name="first_name"
                      register={register}
                      errors={errors?.first_name}
                      placeholder=" Enter First Name"
                      required
                      disabled={!isEditable}
                    />
                  </Box>

                  <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                    <FormTextField
                      label="Last Name"
                      name="last_name"
                      placeholder=" Enter Last Name"
                      register={register}
                      errors={errors}
                      required
                      disabled={!isEditable}
                    />
                  </Box>

                  <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                    <FormTextField
                      label="UHID"
                      name="uh_id"
                      placeholder=" Enter UHID"
                      register={register}
                      errors={errors}
                      required
                      disabled
                    />
                  </Box>

                  <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                    <FormDatePicker
                      label="Date of Birth"
                      name="dob"
                      placeholder=" Enter Date of Birth"
                      control={control}
                      errors={errors}
                      required
                      disabled={!isEditable}
                    />
                  </Box>

                  <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                    <FormSelect
                      label="Gender"
                      name="gender"
                      control={control}
                      errors={errors}
                      disabled={!isEditable}
                      required
                      options={[
                        { label: "Select Gender", value: "" },
                        { label: "Female", value: "Female" },
                        { label: "Male", value: "Male" },
                        { label: "Others", value: "Others" },
                      ]}
                    />
                  </Box>

                  {referenceNumber && (
                    <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                      <FormTextField
                        label="Reference Number"
                        name="referenceNumber"
                        placeholder=" Enter Reference Number"
                        register={register}
                        errors={errors}
                        required
                        disabled
                      />
                    </Box>
                  )}

                  {/* Contact Number */}
                  <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 35%" } }}>
                    <div className="form-group">
                      <Typography
                        sx={{
                          fontSize: "15px",
                          fontWeight: 500,
                          color: "var(--app-text-muted)",
                          mb: "6px",
                          fontFamily: "Figtree",
                        }}
                      >
                        Contact Number <span className="text-danger">*</span>
                      </Typography>

                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Box sx={{ flex: "0 0 20%" }}>
                          <CountryCodePicker disabled={true} />
                        </Box>

                        <Box sx={{ flex: "1" }}>
                          <TextField
                            fullWidth
                            variant="filled"
                            hiddenLabel
                            type="text"
                            {...register("phoneNumber")}
                            placeholder="Enter Mobile Number"
                            disabled
                            InputProps={{
                              disableUnderline: true,
                              sx: {
                                minHeight: "48px",
                                borderRadius: "8px",
                                backgroundColor: "var(--app-surface-2)",
                                border: "1px solid var(--app-border)",
                                px: "12px",
                                display: "flex",
                                alignItems: "center",

                                "& .MuiInputBase-input": {
                                  fontSize: "14px",
                                  fontWeight: 400,
                                  fontFamily: "Figtree",
                                  color: "var(--app-text-muted)",
                                  WebkitTextFillColor: "var(--app-text-muted)",
                                  padding: "12px 0",
                                },

                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  fontWeight: 400,
                                  color: "var(--app-text-muted)",
                                  opacity: 1,
                                },

                                "&.Mui-disabled": {
                                  backgroundColor: "var(--app-surface-2)",
                                  border: "1px solid var(--app-border)",
                                },
                              },
                            }}
                            sx={{
                              "& .MuiFilledInput-root:before, & .MuiFilledInput-root:after": {
                                display: "none",
                              },

                              "& .MuiFilledInput-root:hover:not(.Mui-disabled):before": {
                                display: "none",
                              },
                            }}
                          />
                        </Box>
                      </Box>

                      {errors.phoneNumber && (
                        <span className="text-danger">
                          {errors.phoneNumber}
                        </span>
                      )}
                    </div>
                  </Box>

                  <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 35%" } }}>
                    <FormTextField
                      label="Email Address"
                      name="email"
                      placeholder=" Enter Email Address"
                      register={register}
                      errors={errors}
                      // required
                      disabled={!isEditable}
                    />
                  </Box>

                  {patient?.isAbhaVerified && (
                    <>
                      <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 100%" } }}>
                        <FormTextField
                          label="Address"
                          name="abhaDetails.address"
                          register={register}
                          errors={errors}
                          required
                          disabled
                        />
                      </Box>

                      <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                        <FormTextField
                          label="Pin Code"
                          name="abhaDetails.pinCode"
                          register={register}
                          errors={errors}
                          required
                          disabled
                        />
                      </Box>

                      <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                        <FormTextField
                          label="State"
                          name="abhaDetails.state"
                          register={register}
                          errors={errors}
                          required
                          disabled
                        />
                      </Box>

                      <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                        <FormTextField
                          label="City"
                          name="abhaDetails.district"
                          register={register}
                          errors={errors}
                          required
                          disabled
                        />
                      </Box>

                      <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 49%" } }}>
                        <FormTextField
                          label="ABHA Number"
                          name="abhaDetails.abhaNumber"
                          register={register}
                          errors={errors}
                          required
                          disabled
                        />
                      </Box>

                      <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 49%" } }}>
                        <FormTextField
                          label="ABHA Address"
                          name="abhaDetails.abhaAddress"
                          register={register}
                          errors={errors}
                          required
                          disabled
                        />
                      </Box>
                    </>
                  )}
                </Box>
              </div>

              {patientSessionToken != null && (
                <Box
                  component="aside"
                  sx={{
                    position: "fixed",
                    backgroundColor: "var(--app-surface-2)",
                    bottom: 0,
                    padding: "10px 0",
                    // animate the right property so it moves smoothly when `open` changes
                    right: open ? "-20px" : "200px",
                    width: "100%",
                    zIndex: 1000,
                    transition: "right 300ms cubic-bezier(.22,.9,.29,1)",
                    // keep the outer container non-interactive so it doesn't block clicks
                    pointerEvents: "none",
                    display: "flex",
                    justifyContent: "flex-start", // we use marginLeft on inner box to mimic previous layout
                  }}
                >
                  <Box
                    sx={{
                      // this is the visible area for the button
                      pointerEvents: "auto", // enable clicks for the actual button
                      ml: "21%", // keep same visual offset as original (change if needed)
                      // ensure the button area doesn't get cut off if right is negative
                      transform: "translateY(0)",
                    }}
                  >
                    {buttonLoading ? (
                      <Button
                        variant="contained"
                        disabled
                        sx={{
                          width: 200,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 1,
                          backgroundColor: "#5751E9",
                          color: "#fff",
                          boxShadow: "0 6px 12px rgba(87,81,233,0.12)",
                        }}
                      >
                        <CircularProgress
                          size={16}
                          thickness={6}
                          color="inherit"
                        />
                        <Box component="span" sx={{ srOnly: "true", ml: 1 }}>
                          Loading...
                        </Box>
                      </Button>
                    ) : (
                      isChanged &&
                      isEditable && (
                        <Button
                          type="submit" /* or onClick={onSave} */
                          variant="contained"
                          disabled={!isEditable}
                          sx={{
                            width: "169px",
                            height: "48px",
                            backgroundColor: "#5751E9",
                            color: "#fff",
                            textTransform: "none",
                            borderRadius: "8px",
                            fontSize: "15px",
                            fontWeight: "500",
                            fontFamily: "Figtree",
                            "&:hover": { backgroundColor: "#4b47d6" },
                            gap: 1,
                          }}
                        >
                          <Icon
                            icon="material-symbols:edit"
                            width="15"
                            height="15"
                            style={{ color: "#FFFFFF" }}
                          />
                          Update Details
                        </Button>
                      )
                    )}
                  </Box>
                </Box>
              )}
            </>
          </form>
        </Paper>
      </Container>

      {patientSessionToken == null && (
        <Box
          sx={{
            p: 3,
            mt: 3,
            borderRadius: "12px",
            border: "1px solid #FFFF",
            backgroundColor: "var(--app-surface)",
          }}
        >
          {!sendOTP ? (
            <>
              <Typography
                variant="h6"
                fontWeight={700}
                mb={1}
                fontSize={18}
                fontFamily={"figtree"}
              >
                Update Details
              </Typography>

              <Typography
                mb={2}
                sx={{
                  fontFamily: "figtree",
                  fontWeight: 400,
                  fontSize: 14,
                }}
              >
                To update patient details, you need to verify the patient’s
                mobile number{" "}
                <Typography component="span" fontWeight={700}>
                  {patient?.phoneNumber || ""}
                </Typography>{" "}
                via OTP
              </Typography>

              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                <Box>
                  <button
                    type="button"
                    className="btn btn-added-primary"
                    onClick={() => handlesendOTP()}
                    disabled={sendOtpLoading}
                  >
                    {sendOtpLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        &nbsp;Sending...
                      </>
                    ) : (
                      "Send OTP"
                    )}
                  </button>
                </Box>

                {/* <Box>
                  <button type="submit" className="btn btn-added-danger">
                    Cancel
                  </button>
                </Box> */}
              </Box>
            </>
          ) : (
            <>
              <Typography variant="h6" fontWeight={600} mb={1}>
                Verify OTP
              </Typography>

              <Typography mb={2}>
                Please enter the OTP sent to{" "}
                <Typography component="span" fontWeight={600}>
                  {patient?.phoneNumber ? `${patient?.phoneNumber}` : ""}
                </Typography>
              </Typography>

              <Box sx={{ mb: 3 }}>
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  length={6}
                  disabled={verifyOtpLoading}
                  autoFocus
                />
              </Box>

              <Timer
                seconds={30}
                minutes={0}
                resend={handlesendOTP}
                text={"Resend OTP in"}
                buttonColor={"var(--app-text)"}
                background="var(--app-surface)"
                ButtonText={"Didn't get the code? Resend OTP"}
              />

              <Box sx={{ mt: 4 }}>
                <button
                  type="button"
                  className="btn btn-added-primary"
                  onClick={() => otpVerification(otp)}
                  disabled={verifyOtpLoading || otp?.length !== 6}
                >
                  {verifyOtpLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      &nbsp;Verifying...
                    </>
                  ) : (
                    "Proceed"
                  )}
                </button>
              </Box>
            </>
          )}
        </Box>
      )}
    </>
  );
};

const CalendarIcon = () => <Icon icon="uiw:date" width="20" height="20" />;
export default PatientProfile;
